export default class AzureDatabaseService {
  public static AZURE_DATABASE_PORT_DEFAULT: number = 1433;
  public static AZURE_DATABASE_SCHEMA_DEFAULT: string = 'dbo';
}
